<template>
<div class="columns is-multiline">
    <div class="column is-full">
        <div class="stats-box">
            <div class="columns">
                <div class="column is-3">
                    <div class="stats-icon">
                        <font-awesome-icon class="active-backups-icon" icon="play"/>
                    </div>
                </div>
                <div class="column is-9">
                    <h2 class="stats-title">Active snapshots & backups</h2>
                    <h3 class="stats-description">{{ activeSnapshotsText }}</h3>
                </div>
            </div>
        </div>
    </div>
    <div class="column is-full">
        <div class="stats-box">
            <div class="columns">
                <div class="column is-3">
                    <div class="stats-icon">
                        <font-awesome-icon icon="hdd"/>
                    </div>
                </div>
                <div class="column is-9">
                    <h2 class="stats-title">Storage used</h2>
                    <h3 class="stats-description">{{ snapshotsStorageText }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            activeSnapshots: null,
            activeSnapshotsAndBackups: null,
            snapshotsStorage: null,
            snapshotsAndBackupsStorage: null,
        }
    },

    mounted() {
        this.getStats();
    },

    methods: {
        getStats() {
            Api().get('users/current/stats/snapshots-stats')
                .then((success) => {
                    this.activeSnapshots = success.data.active_snapshots_count;
                    this.snapshotsStorage = success.data.snapshots_storage;

                    this.activeSnapshotsAndBackups = success.data.active_snapshots_and_backups_count;
                    this.snapshotsAndBackupsStorage = success.data.snapshots_and_backups_storage;
                })
                .catch((error) => {
                    //
                });
        },
    },

    computed: {
        activeSnapshotsText() {
            if (this.activeSnapshotsAndBackups === null) {
                return '-';
            }

            return this.activeSnapshotsAndBackups;
        },

        snapshotsStorageText() {
            if (this.snapshotsAndBackupsStorage === null) {
                return '-';
            }

            return this.snapshotsAndBackupsStorage + ' GB';
        },
    },
}
</script>
